export default __webpack_public_path__ + "locales/tr/SendInviteDialog.json?hash=a623c9e963853da261a6e06540c36528";